import { Bounds, IsBounds } from "../geometry";
import { RoundRobin } from "./tree.spatial.interfaces";
export class QuadtreeSplitter {
    split(node, options) {
        if (node.boundingBox) {
            const { xmin, ymin, zmin, width, height } = node.boundingBox;
            const halfWidth = width / 2;
            const halfHeight = height / 2;
            const midX = xmin + halfWidth;
            const midY = ymin + halfHeight;
            return [
                new Bounds(xmin, ymin, halfWidth, halfHeight, zmin, 0),
                new Bounds(xmin, midY, halfWidth, halfHeight, zmin, 0),
                new Bounds(midX, ymin, halfWidth, halfHeight, zmin, 0),
                new Bounds(midX, midY, halfWidth, halfHeight, zmin, 0),
            ];
        }
        return [];
    }
}
export class OctreeSplitter {
    split(node, options) {
        if (node.boundingBox) {
            const { xmin, ymin, zmin, width, height, depth } = node.boundingBox;
            const halfWidth = width / 2;
            const halfHeight = height / 2;
            const midX = xmin + halfWidth;
            const midY = ymin + halfHeight;
            const halfDepth = depth / 2;
            const midZ = zmin + halfDepth;
            return [
                new Bounds(xmin, ymin, halfWidth, halfHeight, zmin, halfDepth),
                new Bounds(xmin, midY, halfWidth, halfHeight, zmin, halfDepth),
                new Bounds(midX, ymin, halfWidth, halfHeight, zmin, halfDepth),
                new Bounds(midX, midY, halfWidth, halfHeight, zmin, halfDepth),
                new Bounds(xmin, ymin, halfWidth, halfHeight, midZ, halfDepth),
                new Bounds(xmin, midY, halfWidth, halfHeight, midZ, halfDepth),
                new Bounds(midX, ymin, halfWidth, halfHeight, midZ, halfDepth),
                new Bounds(midX, midY, halfWidth, halfHeight, midZ, halfDepth),
            ];
        }
        return [];
    }
}
export class KdtreeSplitter {
    constructor(splitAxisSelector, dimension = 2) {
        this.splitAxisSelector = splitAxisSelector;
        this.dimension = dimension;
    }
    split(node, options) {
        if (node.boundingBox) {
            const { xmin, ymin, zmin, width, height, depth } = node.boundingBox;
            const halfWidth = width / 2;
            const halfHeight = height / 2;
            const midX = xmin + halfWidth;
            const midY = ymin + halfHeight;
            const halfDepth = depth / 2;
            const midZ = zmin + halfDepth;
            const axe = this.splitAxisSelector ? this.splitAxisSelector(node.depth, this.dimension ?? 3) : RoundRobin(node.depth, this.dimension ?? 3);
            switch (axe) {
                case 0:
                    let center = node.items?.data.map((item) => (IsBounds(item) ? item.center.x : item.boundingBox?.center.x ?? midX));
                    if (center && center.length > 0) {
                        const splitPlane = center.reduce((a, b) => a + b, 0) / center.length;
                        const size = splitPlane - xmin;
                        return [
                            new Bounds(xmin, ymin, size, height, zmin, depth),
                            new Bounds(splitPlane, ymin, size, height, zmin, depth),
                        ];
                    }
                    break;
                case 1:
                    center = node.items?.data.map((item) => (IsBounds(item) ? item.center.y : item.boundingBox?.center.y ?? midY));
                    if (center && center.length > 0) {
                        const splitPlane = center.reduce((a, b) => a + b, 0) / center.length;
                        const size = splitPlane - ymin;
                        return [
                            new Bounds(xmin, ymin, width, size, zmin, depth),
                            new Bounds(xmin, splitPlane, width, size, zmin, depth),
                        ];
                    }
                    break;
                case 2:
                    center = node.items?.data.map((item) => (IsBounds(item) ? item.center.z : item.boundingBox?.center.z ?? midZ));
                    if (center && center.length > 0) {
                        const splitPlane = center.reduce((a, b) => a + b, 0) / center.length;
                        const size = splitPlane - zmin;
                        return [
                            new Bounds(xmin, ymin, width, height, zmin, size),
                            new Bounds(xmin, ymin, width, height, splitPlane, size),
                        ];
                    }
                    break;
            }
        }
        return [];
    }
}
//# sourceMappingURL=tree.spatial.splitters.js.map